var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2734_23097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 11.6424V17.1511L8.64914 18.3119C8.81613 18.5622 9.18422 18.5622 9.35121 18.3119L10.125 17.1511V11.6424C9.75973 11.7099 9.38461 11.75 9 11.75C8.61539 11.75 8.24027 11.7099 7.875 11.6424ZM9 0.5C6.20402 0.5 3.9375 2.76652 3.9375 5.5625C3.9375 8.35848 6.20402 10.625 9 10.625C11.796 10.625 14.0625 8.35848 14.0625 5.5625C14.0625 2.76652 11.796 0.5 9 0.5ZM9 3.17188C7.68164 3.17188 6.60938 4.24414 6.60938 5.5625C6.60938 5.79524 6.42023 5.98438 6.1875 5.98438C5.95477 5.98438 5.76562 5.79524 5.76562 5.5625C5.76562 3.77902 7.21688 2.32813 9 2.32813C9.23273 2.32813 9.42188 2.51727 9.42188 2.75C9.42188 2.98273 9.23273 3.17188 9 3.17188Z",
    fill: "#585858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2734_23097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.39b0221851c4b931783e4511248d14c5.svg";
export { ForwardRef as ReactComponent };